import React from 'react';
import classNames from 'classnames';
import TableItem from '../TableItem/TableItem';
import ImageBox from '../../TableColumns/ImageBox/ImageBox';
import Text from '../../TableColumns/Text/Text';
import RowHandler from '../../TableColumns/RowHandler/RowHandler';
import EmptyIcon from '../../EmptyIcon/EmptyIcon';
import { getExtensionCmpByViewPath  } from '../../util/extension';
require('./TableList.scss');

class TableList extends React.Component {
	constructor(props) {
		super(props);
	}

	rowButtonItemTouchHandler(index, button) {
		this.props.rowButtonItemTouchTap && this.props.rowButtonItemTouchTap(button, index);
	}

	onRowTouchTap(index,id) {
		if(this.props.onRowTouchTap) {
			this.props.onRowTouchTap(id,index);
		}
	}

	// 模版转化为组件
	convertToComponent(params) {
        const { cmpName, row, columns, index, extensionCmp, hasRowHandler, isContent, onRowTouchTap, prefCmpProps } = params;
        // 如果有自定义组件 则渲染自定义组件
        if(extensionCmp) {
            let destCmpName = cmpName;
            // 如果是内容区  在所有字段中过滤掉传过来数组中的字段  渲染到内容区
            if(isContent) {
               let allCmpNames = [];
               columns.map(cmp => {
                   allCmpNames.push(cmp.cmp_data.name);
               });

               for(let i = 0; i < allCmpNames.length; i++) {
                    destCmpName.map(item => {
                        if(allCmpNames[i] == item) {
                            allCmpNames.splice(i,1);
                            i--;
                        }
                    });
               }

                destCmpName = allCmpNames;
            }
            const DestCmp = getExtensionCmpByViewPath(extensionCmp);
            return (<DestCmp row={row}
                        columns={columns}
                        cmpName={destCmpName}
						{...prefCmpProps} />);
        }

        if(Array.isArray(cmpName) && cmpName[0] == 'RowHandler') {
            return hasRowHandler ? <RowHandler onRowTouchTap={onRowTouchTap} id={row._id.value} index={index} /> : null;
        }

        let cmpType = '';
        columns.map(column => {
            if(column.cmp_data.name === cmpName) {
                cmpType = column.cmp_type;
            }
        });

        let rowValue = row[cmpName] ? row[cmpName].text : '';
        if(cmpType === 'StandradDate') {
            const reg = /\//g;
            rowValue = rowValue.replace(reg,'-');
        }

        switch(cmpType) {
			case 'PicUpload':
				return <ImageBox src={row[cmpName] ? row[cmpName].clientUrl || row[cmpName].value : ''} />;

            default:
                return <Text text={rowValue} />;
		}
    }

	render() {
		const { style
				,cls
				,tableType
				,standardFormatedRows,originRows,rowTemplate,rowsLimit
				,originColumns,tableColumn
				,hasRowHandler,isSyncRowHandler
				,hasAvatars
				,showChecked,selectIds,globleChecked
				,isAndroid
				,rowButtonList
				,onTouchTap
				,containerHeight
				,num
				,setClickPos
			    ,getEmptyHeight } = this.props;

		let rows = Object.assign([],standardFormatedRows);
		let listCls = classNames('standard-list', cls);

		if(rowTemplate) {
			rows = Object.assign([],originRows);
            if(rowsLimit) {
                if(rows.length > rowsLimit) {
                    rows = rows.slice(0,rowsLimit);
                }
            }
			listCls = classNames('tpl-list', cls,{ 'isElearning': BSGlobal.application === 'ELearning' });
		}

		if(rows && rows.length > 0) {
			return (
			<ul className={listCls} style={style}>
				{
					rows.map((row ,index) => {
						return (<TableItem key={index}
										index={index}
										row={row}
										tableType={tableType}
										actions={this.props.actions}
										columns={originColumns}
										tableColumn={tableColumn}
										convertToComponent={this.convertToComponent}
                                        tpl={rowTemplate}
										hasRowHandler={hasRowHandler}
										isSyncRowHandler={isSyncRowHandler}
										hasAvatars={hasAvatars}
                                        showChecked={showChecked}
                                        checked={globleChecked || selectIds && selectIds.indexOf(row['_id'].value) >= 0}
										isAndroid={isAndroid}
										rowButtonList={rowButtonList ? rowButtonList[index] : []}
										onTouchTap={onTouchTap}
										rowButtonItemTouchTap={this.rowButtonItemTouchHandler.bind(this,index)}
										onRowTouchTap={this.onRowTouchTap.bind(this,index)}
                                        setClickPos={setClickPos}
                                        partId={this.props.partId}
								/>);
					})
				}
			</ul>);
		}
		return (<EmptyIcon containerHeight={containerHeight}
         				  num={num}
						  getHeight={getEmptyHeight}
         		/>);
	}
}

export default TableList;



// WEBPACK FOOTER //
// ./src/components/Table_Components/TableList/TableList.js